module.exports = __webpack_public_path__ + "img/kg.d5b94388.svg";